import Header from 'components/Header/Header';
import { SITE } from 'config/config';
import { useEffect, useState } from 'react';
import { getAllSetting } from 'service/base';
import { twMerge } from 'tailwind-merge';
import { SETTING_KEYS } from 'utils/common/const';

const RulePage = () => {
  const [dataSettings, setDataSettings] = useState([]);

  useEffect(() => {
    fetchAllSetting();
  }, []);

  const fetchAllSetting = async () => {
    try {
      const res = await getAllSetting({ site: SITE });
      setDataSettings(res?.data || []);
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  return (
    <div className={twMerge(SITE, 'w-full h-full')}>
      <img
        src="bg.png"
        alt="Background"
        className="w-full h-full fixed right-0 bottom-0 object-cover object-center"
      />
      <img
        src="/assets/images/bao.png"
        alt=""
        className="pointer-events-none fixed bottom-[60px] left-[32px] z-[1] hidden lg:block"
      />
      <img
        src="/assets/images/chim.png"
        alt=""
        className="pointer-events-none fixed bottom-[55px] right-[20px] z-[1] hidden lg:block"
      />
      <div className="container relative z-10 pb-[24px] md:pb-[32px] px-2">
        <Header />
        <div className="mx-auto max-w-[1200px] mt-2 bg-white border-[2px] border-solid border-[#FB8C00] shadow shadow-primary p-4 w-full md:pb-8 md:pt-4 rounded-3xl">
          <div
            className="rule-html-content"
            dangerouslySetInnerHTML={{
              __html: dataSettings?.find((item) => item.key === SETTING_KEYS.RULE)?.content
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default RulePage;
